import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IP_URL from "../connect";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useSelector } from "react-redux";
import { selectUser } from "../../Redux/currentUserSlice";
import Sidebar from "../Sidebar";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// -------- Styled Components --------
const Main = styled.div`
  background: #f5f7fa;
  min-height: 100vh;
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  font-family: "Inter", Arial, sans-serif;
  background: white;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.5s ease-in-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    margin: 10px;
    padding: 10px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 25px;
  color: #2c3e50;
  font-size: 1.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  padding: 25px;
  border-radius: 12px;
  color: #fff;
  margin-bottom: 25px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
`;

const Section = styled.div`
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(255, 255, 255, 0.22);
    transform: translateY(-3px);
  }

  p {
    font-size: 1.3rem;
    margin-bottom: 6px;
    opacity: 0.95;

    @media(max-width: 600px){
     margin: 0;
     font-size: 0.9rem;
     padding:0;
    }
  }

  span {
    font-size: 0.95rem;
    font-weight: 700;
    color: #fff;
  }

  @media(max-width:600px) {
   text-align: left;
   display: flex;
   align-items: center;
   padding: 10px;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;

`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
`;

const Th = styled.th`
  padding: 12px;
  border: 1px solid #ddd;
  text-align: center;
  background: #43a047;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 13px;
`;

const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 14px;
  color: #333;
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background: #f9f9f9;
  }
  &:hover {
    background: #e8f5e9;
    transition: background 0.3s;
  }
`;

const Loading = styled.div`
  text-align: center;
  margin-top: 80px;
  font-size: 18px;
  color: #555;
`;

const SearchInput = styled.input`
  padding: 5px;
  text-align: center;
  width: 95%;
  border-radius: 6px;
  border: 1px solid #ccc;
  &:focus {
    outline: none;
    border-color: #4caf50;
  }
`;

const TotalRow = styled.tr`
  background-color: #e0e0e0;
  font-weight: bold;
  td {
    padding: 10px;
  }
`;


const OrganizationMpesaPayments = () => {

    const [payments, setPayments] = useState([]);
      const [filteredPayments, setFilteredPayments] = useState([]);
      const [loading, setLoading] = useState(true);
      const [orgData, setOrgData] = useState('');
      const [serialFilter, setSerialFilter] = useState("");
      const [dateFilter, setDateFilter] = useState("");
      const { token, uniqueKey } = useSelector(selectUser);
      const navigate = useNavigate();
      const user = useSelector(selectUser);
      const [sidebarOpen, setSidebarOpen] = useState(false);
    
      const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
      };
    
      //Fetch org Data
      useEffect(() => {
        const fetchOrgData = async() =>{
            try{
                const response = await fetch(`${IP_URL}/organization/${uniqueKey}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type" : "application/json",
                    }
                })
                const data = await response.json()
                setOrgData(data)
              
            
 setLoading(false);
            } catch (error) {
            console.error("Error fetching organization data:", error);
            toast.error(
              "Error fetching organization data:", error
            )
setLoading(false)
            }
        }

        fetchOrgData()
      },[token, uniqueKey])

      //Fetch payments for organizations
      useEffect(() => {
        const fetchPayments = async () => {
          const toastId = toast.loading("Loading M-Pesa payments...");
          try {
            const response = await fetch(`${IP_URL}/prepaid/org-payments?uniqueKey=${uniqueKey}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
            const data = await response.json();
               if (Array.isArray(data)) {
                      setPayments(data);
                      setFilteredPayments(data);
                      toast.update(toastId, {
                        render: "Payments loaded successfully ✅",
                        type: "success",
                        isLoading: false,
                        autoClose: 2500,
                      });
                      } else {
          throw new Error("Invalid data format received");
        }
          } catch (error) {
           console.error("Error fetching payments:", error);
                   toast.update(toastId, {
                     render: "Error loading payments ❌",
                     type: "error",
                     isLoading: false,
                     autoClose: 4000,
                   });
                 } finally {
                   setLoading(false);
                 }
        };
    
        fetchPayments();
      }, [token]);
    
      // Filter logic
      useEffect(() => {
        let filtered = payments;
    
        if (serialFilter) {
          filtered = filtered.filter((p) =>
            p.billRefNumber.toLowerCase().includes(serialFilter.toLowerCase())
          );
        }
    
        if (dateFilter) {
          filtered = filtered.filter((p) =>
            p.transTime.startsWith(dateFilter.replace(/-/g, ""))
          );
        }
    
        setFilteredPayments(filtered);
      }, [serialFilter, dateFilter, payments]);
    
      // Date formatting helper
      const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        return `${day}/${month}/${year.slice(-2)} ${hour}:${minute}`;
      };
    
      const totalAmount = filteredPayments.reduce(
        (sum, p) => sum + parseFloat(p.transAmount || 0),
        0
      );
      const totalUnitsGenerated = filteredPayments.reduce(
        (sum, p) => sum + parseFloat(p.unitsGenerated || 0),
        0
      );
    
      //Get Orgs balance
    const latestPayment = payments.reduce((latest, current) => {
      return !latest || current.transTime > latest.transTime ? current : latest;
    }, null);
    
    const latestBalance = latestPayment ? parseFloat(latestPayment.orgAccountBalance) : 0;
    
      if (loading) return <Loading>Loading...</Loading>;
  return (
       <Main>
      <Navbar showMenuButton toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Container>
        <Title>M-Pesa Payments</Title>

        <SectionWrapper>
          <Section>
            <p>Mpesa Balance:</p>
            <span>KES {latestBalance.toFixed(2)}</span>
          </Section>
          <Section>
            <p>Org ShortCode:</p>
            <span>{orgData.shortCode}</span>
          </Section>
          <Section>
            <p>Amount per Unit:</p>
            <span>Ksh {orgData.ratePerCubicMeter}</span>
          </Section>
        
        </SectionWrapper>

        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <Th></Th>
                <Th></Th>
                <Th>
                  <SearchInput
                    type="text"
                    placeholder="Search Account"
                    value={serialFilter}
                    onChange={(e) => setSerialFilter(e.target.value)}
                  />
                </Th>
                <Th></Th>
                <Th></Th>
                <Th>
                  <input
                    type="date"
                    value={dateFilter}
                    onChange={(e) => setDateFilter(e.target.value)}
                  />
                </Th>
              </tr>
              <tr>
                <Th>Transaction ID</Th>
                <Th>Name</Th>
                <Th>Account No</Th>
                <Th>Amount (Ksh)</Th>
                <Th>Units Generated</Th>
                <Th>Time</Th>
              </tr>
            </thead>
            <tbody>
              {filteredPayments.map((payment) => (
                <Tr key={payment._id}>
                  <Td>{payment.transID}</Td>
                  <Td>{payment.firstName}</Td>
                  <Td>{payment.billRefNumber}</Td>
                  <Td>{payment.transAmount}</Td>
                  <Td>{(payment.unitsGenerated / 1000 || "-") .toFixed(3)} m³</Td>
                  <Td>{formatDate(payment.transTime)}</Td>
                </Tr>
              ))}
              <TotalRow>
                <td colSpan="2">Total</td>   
                <td></td>
                <td>{totalAmount.toFixed(2)}</td>
                <td></td>
                <td></td>
              </TotalRow>
            </tbody>
          </Table>
        </TableWrapper>
      </Container>

      <Footer />

      
    </Main>
  );
};

  

export default OrganizationMpesaPayments